import { apiSlice } from "./apiSlice";
import { apiRoutes } from "../../config/api";

export const trackntraceService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTrackNTraceTag: builder.query({
      query: (params: Record<string, unknown>) => ({
        url: apiRoutes.TRACK_N_TRACE_TAG,
        params: params,
        method: "GET",
      }),
    }),
    getTrackNTraceTagEpcis: builder.query({
      query: (params: any) => ({
        url: `${apiRoutes.EPCIS_HISTORY}`,
        method: 'GET',
        params,
      }),
    }),
    getTrackNTraceCountsByUser: builder.query({
      query: (params: Record<string, unknown>) => ({
        url: apiRoutes.TRACK_N_TRACE_COUNTS_BY_USER,
        params: params,
        method: "GET",
      }),
    }),
    getTrackNTraceReceiveAsn: builder.query({
      query: (params: Record<string, unknown>) => ({
        url: apiRoutes.TRACK_N_TRACE_RECEIVE_ASN,
        params,
        method: "GET",
      }),
    }),
    getTrackNTraceAsnLines: builder.query({
      query: ({ asn, ...params }: { asn: string;[key: string]: unknown }) => ({
        url: `${apiRoutes.TRACK_N_TRACE_ASN_LINES}/${encodeURIComponent(asn)}/lines`,
        params,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetTrackNTraceTagQuery,
  useGetTrackNTraceTagEpcisQuery,
  useGetTrackNTraceCountsByUserQuery,
  useGetTrackNTraceReceiveAsnQuery,
  useGetTrackNTraceAsnLinesQuery,
} = trackntraceService;
